import api from '@/api'

const { $qSystem, $pricing, $academic } = api;

export const { $ceos } = $academic;
export const { $exams, $examsException } = $qSystem;
export const { $types } = $pricing;
